import React, { memo, SVGProps } from 'react'

export const Device = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.4432 5.05536H9.55681C8.10049 5.05536 6.91681 6.23904 6.91681 7.69536V16.3056C6.91681 17.7619 8.10049 18.9456 9.55681 18.9456H14.4432C15.8995 18.9456 17.0832 17.7619 17.0832 16.3056V7.69536C17.0832 6.23904 15.8995 5.05536 14.4432 5.05536ZM15.6432 16.3046C15.6432 16.9661 15.1046 17.5046 14.4432 17.5046H9.55681C8.89537 17.5046 8.35681 16.9661 8.35681 16.3046V7.6944C8.35681 7.03296 8.89537 6.4944 9.55681 6.4944H9.90817C9.96289 6.83712 10.248 7.104 10.6061 7.104H13.3939C13.752 7.104 14.0362 6.83712 14.0918 6.4944H14.4432C15.1046 6.4944 15.6432 7.03296 15.6432 7.6944V16.3046Z"
      fill="currentColor"
    />
  </svg>
))
